module.exports = __webpack_public_path__ + "img/404.5c4128ed.jpg";